<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,18.999c-0.4,0-0.776-0.156-1.059-0.438L0.22,7.841C0.078,7.699,0,7.511,0,7.31c0-0.2,0.078-0.389,0.22-0.53
		c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22L12,17.499L22.72,6.78c0.142-0.142,0.33-0.22,0.53-0.22
		s0.389,0.078,0.53,0.22C23.922,6.922,24,7.11,24,7.31c0,0.2-0.078,0.389-0.22,0.53L13.06,18.56
		C12.778,18.843,12.401,18.999,12,18.999z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'arrow-down-1',
    },
    name: {
      type: String,
      required: false,
      default: 'ArrowDown1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>